import { render } from "./VideoRealtimeWeiye.vue?vue&type=template&id=e0e3ad9c&scoped=true"
import script from "./VideoRealtimeWeiye.vue?vue&type=script&lang=ts"
export * from "./VideoRealtimeWeiye.vue?vue&type=script&lang=ts"

import ".././assets/styles/videoRealtime.css?vue&type=style&index=0&lang=css"
import "./VideoRealtimeWeiye.vue?vue&type=style&index=1&id=e0e3ad9c&lang=scss&scoped=true"
import "./VideoRealtimeWeiye.vue?vue&type=style&index=2&id=e0e3ad9c&lang=css"
script.render = render
script.__scopeId = "data-v-e0e3ad9c"

export default script